import { render, staticRenderFns } from "./settings-category.vue?vue&type=template&id=efef3ed0&scoped=true&"
import script from "./settings-category.vue?vue&type=script&lang=js&"
export * from "./settings-category.vue?vue&type=script&lang=js&"
import style0 from "./settings-category.vue?vue&type=style&index=0&id=efef3ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efef3ed0",
  null
  
)

export default component.exports